export const timeZone = 'Asia/Bangkok'
export const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const LongDateTimeFormat = 'ddd MMM D, YYYY HH:mm'
export const ShortDateTimeFormat = 'D MMM YYYY HH:mm'
export const LongDateFormat = 'ddd, DD MMM YYYY'
export const ShortDateFormat = 'D MMM YYYY'
export const timeFormat = 'HH:mm'


// WEBPACK FOOTER //
// ./src/front/lib/setting.js